
















import router from "../router";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { GuardileoVueComponent } from '@/lib';
import { UserModule, UserStore } from "@/store/modules/currentuser-store";
import { Berechtigungen, hat_Berechtigung } from '@/lib';
import {KundeService} from "@/services/kunde-service";

@Component({
})
export default class SelfService extends GuardileoVueComponent {

    private kundeService: KundeService = new KundeService();

    async created() {
    }

    async mounted() {
        await UserStore.ensureCurrentData();
    }

    private async settings() {
        router.push('/selfservice');
    }


    private async weiter_zum_dashboard() {

        const kunden = await this.kundeService.GetList();


        if (kunden.length > 1) {
            this.$modal.show('mymodal');
        }

        if (hat_Berechtigung(UserStore.effektive_Berechtigungen, null, 'Nach_Anmeldung_Kunde_waehlen')) {
            router.push('/choosekunde');
            this.$modal.show('mymodal');
        } else {
            router.push('/');
        }
    }       
}
